var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChooseIcon04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83336 4.25H31.1667C32.7315 4.25 34 5.51856 34 7.08336V26.9167C34 28.4815 32.7315 29.75 31.1666 29.75H2.83336C1.26856 29.75 0 28.4815 0 26.9166V7.08336C0 5.51856 1.26856 4.25 2.83336 4.25Z",
    fill: "#CCF2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 9.91663H0V15.5833H34V9.91663Z",
    fill: "url(#paint0_linear_118_146)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7499 19.8334H19.8333V22.6667H29.7499V19.8334Z",
    fill: "#67D9FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.4166H4.25V25.5H17V18.4166Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_146",
    x1: 7.08347,
    y1: 22.668,
    x2: 26.9168,
    y2: 2.83473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D9F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseIcon04);
export default __webpack_public_path__ + "static/media/choose_icon04.34ad04efb46d42944ca2eef0f3b32ae1.svg";
export { ForwardRef as ReactComponent };